(function($) {
    $(document).ready(function() {

        //HOME

        //START custom home slider one
        var page_flexsliderone = $('.flex-one .slider').flickity({
            autoPlay: true,
            fade: true,
            draggable: true,
            cellSelector: '.slide',
            prevNextButtons: false,
            cellAlign: 'center',
            wrapAround: true,
            //lazyLoad: true,
            contain: false,
            pageDots: false,
            //adaptiveHeight: true,
            resize: true,
            setGallerySize: false

        });
        //STOP custom home slider one


        //SINGLE PRODUCT

        //START custom gallery carousel
        $('.single-product-wrapper .gallery').flickity({
            autoPlay: false,
            fade: true,
            draggable: true,
            cellSelector: '.image',
            prevNextButtons: false,
            cellAlign: 'center',
            wrapAround: true,
            //lazyLoad: true,
            contain: false,
            pageDots: false,
            adaptiveHeight: false,
        });

        $('.single-product-wrapper .gallery-nav').flickity({
            asNavFor: '.single-product-wrapper .gallery',
            autoPlay: false,
            fade: true,
            draggable: true,
            cellSelector: '.image',
            prevNextButtons: false,
            cellAlign: 'left',
            wrapAround: false,
            //lazyLoad: true,
            contain: false,
            pageDots: false,
            adaptiveHeight: false,
        });
        //STOP custom gallery carousel

    });

})
(jQuery);